class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const btn = this.querySelector('.facet-filters .facet-filters__label')
    if (btn) {
      const elmOptions = this.querySelector('.facet-filters .select')
      btn.addEventListener('click', () => {
        elmOptions.classList.toggle('show')
      })
    }

    Array.from(document.querySelectorAll('.mobile-facets .mobile-facets__main .mobile-facets__details')).forEach(element => {
      let elmActiveOption = element.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked')
      if (elmActiveOption.length > 0) {
        if(element.querySelector('.count-active-option')) {
          element.querySelector('.count-active-option').classList.remove('hidden')
          element.querySelector('.count-active-option').textContent = '(' + elmActiveOption.length + ')'
        }
      } else {
        if(element.querySelector('.count-active-option')) {
          element.querySelector('.count-active-option').classList.add('hidden')
        }
      }

      if (element.querySelectorAll('.mobile-facets__list input[type="checkbox"]').length == 1) {
        element.classList.add('one-option')
      } else {
        element.classList.remove('one-option')
      }
    })

    if (document.querySelectorAll('.mobile-facets .mobile-facets__list input[type="checkbox"]:checked').length > 0) {
      if(document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.add('option-active')
      }
    } else {
      if(document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.remove('option-active')
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if(document.getElementById('AjaxinatePagination')) {
      new Ajaxinate({
        container: '#product-grid',
        pagination: '#AjaxinatePagination',
        offset: 0,
        callback: function() {
          // Callback function
        }
      });
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const btn = document.querySelector('.facet-filters .facet-filters__label')
    if (btn) {
      const elmOptions = document.querySelector('.facet-filters .select')
      const labelElement = document.querySelector('.facet-filters__label--name');

      btn.addEventListener('click', () => {
        elmOptions.classList.toggle('show')
        if (elmOptions.classList.contains('show')) {
          labelElement.style.display = 'none';
        } else {
          labelElement.style.display = '';
        }
      })
    }
    
    Array.from(document.querySelectorAll('.mobile-facets .mobile-facets__main .mobile-facets__details')).forEach(element => {
      let elmActiveOption = element.querySelectorAll('.mobile-facets__list input[type="checkbox"]:checked')
      if (elmActiveOption.length > 0) {
        if(element.querySelector('.count-active-option')) {
          element.querySelector('.count-active-option').classList.remove('hidden')
          element.querySelector('.count-active-option').textContent = '(' + elmActiveOption.length + ')'
        }
      } else {
        if(element.querySelector('.count-active-option')) {
          element.querySelector('.count-active-option').classList.add('hidden')
        }
      }
    })

    if (document.querySelectorAll('.mobile-facets .mobile-facets__list input[type="checkbox"]:checked').length > 0) {
      if(document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.add('option-active')
      }
    } else {
      if(document.querySelector('.mobile-facets .drawer-link-clear')) {
        document.querySelector('.mobile-facets .drawer-link-clear').classList.remove('option-active')
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    Array.from(document.querySelectorAll('.filter-drawer-count')).forEach(section => {
      section.textContent = '(' + html.getElementById('filter-count').textContent.replace('(', '').replace(')', '').trim() + ')'
    })

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.rangeInputs = this.querySelectorAll(".range-input input");
    this.priceInputs = this.querySelectorAll(".price-input input");
    this.progress = this.querySelector(".slider .progress");
    this.dataSymbol = this.getAttribute('data-symbol') || '';
    this.labelMin = this.querySelector('.label-min-price');
    this.labelMax = this.querySelector('.label-max-price');

    this.priceGap = 0;

    this.querySelectorAll('input').forEach((input) =>
      input.addEventListener('change', this.onRangeChange.bind(this))
    );

    this.querySelectorAll('.range-wrap').forEach(wrap => {
      const range = wrap.querySelector(".range");
      const bubble = wrap.querySelector(".bubble");

      range.addEventListener("input", () => {
        this.setBubble(range, bubble);
      });
      this.setBubble(range, bubble);
    });

    this.handleCustomChangeInput();
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.setMinAndMaxValues();
  }

  setBubble(range, bubble) {
    const val = range.value;
    bubble.innerHTML = `${val}${this.dataSymbol}`;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput.value) minInput.value = '';
    if (!maxInput.value) maxInput.value = '';
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  handleCustomChangeInput() {
    try {
      this.priceInputs.forEach((input) => {
        input.addEventListener("input", (e) => {
          let minPrice = parseInt(this.priceInputs[0].value) || 0;
          let maxPrice = parseInt(this.priceInputs[1].value) || 0;

          if (maxPrice - minPrice >= this.priceGap && maxPrice <= this.rangeInputs[1].max) {
            if (e.target.classList.contains("input-min")) {
              this.rangeInputs[0].value = minPrice;
              this.progress.style.left = (minPrice / this.rangeInputs[0].max) * 100 + "%";
            } else {
              this.rangeInputs[1].value = maxPrice;
              this.progress.style.right = 100 - (maxPrice / this.rangeInputs[1].max) * 100 + "%";
            }
          }
          this.updateLabels(minPrice, maxPrice);
        });
      });

      this.rangeInputs.forEach((input) => {
        input.addEventListener("input", (e) => {
          let minVal = parseInt(this.rangeInputs[0].value) || 0;
          let maxVal = parseInt(this.rangeInputs[1].value) || 0;

          if (maxVal - minVal < this.priceGap) {
            if (e.target.classList.contains("range-min")) {
              this.rangeInputs[0].value = maxVal - this.priceGap;
            } else {
              this.rangeInputs[1].value = minVal + this.priceGap;
            }
          } else {
            this.priceInputs[0].value = minVal;
            this.priceInputs[1].value = maxVal;
            this.progress.style.left = (minVal / this.rangeInputs[0].max) * 100 + "%";
            this.progress.style.right = 100 - (maxVal / this.rangeInputs[1].max) * 100 + "%";
          }
          this.updateLabels(minVal, maxVal);
        });
      });

      this.initLabels();
    } catch (error) {
      console.error('Error in handleCustomChangeInput:', error);
    }
  }

  updateLabels(min, max) {
    if (this.labelMin) this.labelMin.textContent = min + this.dataSymbol;
    if (this.labelMax) this.labelMax.textContent = max + this.dataSymbol;
  }

  initLabels() {
    const minVal = parseInt(this.rangeInputs[0].value) || 0;
    const maxVal = parseInt(this.rangeInputs[1].value) || 0;
    this.updateLabels(minVal, maxVal);

    if (this.progress) {
      this.progress.style.left = (minVal / this.rangeInputs[0].max) * 100 + "%";
      this.progress.style.right = 100 - (maxVal / this.rangeInputs[1].max) * 100 + "%";
    }
  }
}

customElements.define('price-range', PriceRange);




function handleTriggerCloseFilter() {
  const btnClose = document.querySelector('.btn-close-filter')
  if(!btnClose) return

  btnClose.addEventListener('click', function() {
    document.querySelector('.mobile-facets__close').click()
  })
}

handleTriggerCloseFilter()

function rangeMinValFunc(rangeVal){
  const rangeMinWidth = document.querySelector('.range-wrap.min .bubble').textContent = rangeVal
  document.querySelector('.range-wrap.min .bubble').textContent = rangeVal + '€'

  document.querySelector('.range-wrap.min .bubble').style.left = "calc("+rangeMinWidth+"%)"
}

function rangeMaxValFunc(rangeVal){
  const rangeMaxWidth = document.querySelector('.range-wrap.max .bubble').textContent = rangeVal
  document.querySelector('.range-wrap.max .bubble').textContent = rangeVal + '€'
  document.querySelector('.range-wrap.max .bubble').style.left = "calc("+rangeMaxWidth+"%)"
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetSort extends HTMLElement {
  constructor() {
    super();
    const btnSort = this;
    const subBtn = this.querySelector(".facet-sort_by");
    subBtn.addEventListener('click', (e) => {
      btnSort.classList.toggle('open')
    })
  }
}

customElements.define('rocket-facet-sort', FacetSort);
